import i18n from '@/plugins/i18n'

export default [
  // TODO: [Adrian] confirm whether this is a TVP only route
  {
    portalGroup: 'learn.public',
    path: 'policy/refund',
    name: 'Refund Policy',
    component: () => import('@/app/M3001SalesOrderItem/PgRefundPolicy.vue'),
    meta: { title: '退款政策' }
  },
  {
    portalGroup: 'learn.public',
    path: '/content/refund/:id(\\d+)',
    name: 'RefundContentDetails',
    component: () => import('@/app/M3001SalesOrderItem/PgRefund.vue'),
    meta: { title: i18n.t('m3001.refundPage.label'), authenticated: true }
  },
  {
    portalGroup: 'learn.lecture',
    // TODO Alex Change path name
    path: 'refund/:id(\\d+)/review',
    name: 'Refund',
    component: () => import('@/app/M3001SalesOrderItem/PgRefundReview.vue'),
    meta: { title: i18n.t('m3001.refundReviewPage.label'), authenticated: true, permissions: ['approval.review'] }
  }
]
